import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Tooltip } from "react-tooltip";
import Table from "../../../../../../common/element/Table";
import Switcher from "../../../../../../common/element/Switcher";
import Button from "../../../../../../common/element/Buttons";
import ConfirmationModal from "../../../../../../common/Common/ConfirmationModal";
import { useNavigate } from "react-router-dom";
import AddEditSession from "./AddSession";
import ArchiveModal from "../../../../../../common/Common/ArchiveModal";
import {
  enableDisableTool,
  enableDisableAssignment,
  enableDisableSupportDocument,
} from "../../../../../../redux/ScienceOfSelf/Scienceofselfslice";
import { enableDisableScienceOfSelfSession } from "../../../../../../redux/ScienceOfSelf/Scienceofselfslice";
import SweetAlertService from "../../../../../../common/SweetAlert/SweetAlert";
import ThreeDotBouncingLoader from "../../../../../../common/element/ButtonLoader/ThreeDotBouncingLoder";
import CommonIconButton from "../../../../../../common/icons/CommonIconButton";

const { Tr, Th, Td, THead, TBody } = Table;

const formatToolName = (name) => {
  if (!name) return "-";
  return name.split(/[-_]/).map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
};

const SessionList = ({
  sampleData = [],
  currentPage = 1,
  pageLimit = 10,
  scienceId,
  onRefresh,
  loading,
}) => {
  console.log("SessionList - sampleData:", sampleData);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedSession, setSelectedSession] = useState(null);
  const [mode, setMode] = useState("add");
  const [isOpen, setIsOpen] = useState(false);

  const [toggleLoading, setToggleLoading] = useState({});
  const [statusLoading, setStatusLoading] = useState({});
  console.log(toggleLoading, "toggleLoadingtoggleLoading")
  const [confirmationModal, setConfirmationModal] = useState({
    isOpen: false,
    title: "",
    message: "",
    action: null,
  });

  const currentPath = window.location.pathname;
  const searchParams = new URLSearchParams(window.location.search);
  const id = searchParams.get("id");
  const tab = searchParams.get("tab");

  const handleView = (item) => {
    navigate(`${currentPath}?id=${id}&session_id=${item.id}&tab=${tab}&sessionView=view`);
    setMode("view");
  };

  const truncateText = (text, maxLength = 18) => {
    if (!text) return "";
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  };

  const openConfirmationModal = (title, message, onConfirm) => {
    setConfirmationModal({
      isOpen: true,
      title,
      message,
      action: onConfirm,
    });
  };

  const handleConfirmationYes = async () => {
    if (confirmationModal.action) {
      await confirmationModal.action();
    }
    setConfirmationModal({
      isOpen: false,
      title: "",
      message: "",
      action: null,
    });
  };

  const handleConfirmationNo = () => {
    setConfirmationModal({
      isOpen: false,
      title: "",
      message: "",
      action: null,
    });
  };

  const getStatusBadge = (status) => {
    let styles = "";

    switch (status?.toLowerCase()) {
      case "completed":
        styles = "text-green-600 bg-green-50";
        break;
      case "upcoming":
        styles = "text-blue-600 bg-blue-50";
        break;
      case "cancelled":
        styles = "text-red-600 bg-red-50";
        break;
      case "ongoing":
        styles = "text-[#CA8A04] bg-[#FEF9C3]";
        break;
      default:
        styles = "text-gray-600 bg-gray-50";
    }

    return (
      <span className={`inline-block px-3 py-1 text-sm font-medium rounded-full capitalize ${styles}`}>
        {status}
      </span>
    );
  };

  const getToggleTooltip = (type, item) => {
    if (type === "docs") {
      if (item.supported_doc_enabled) return "Supported document already sent";
      return "Send the supported document";
    }

    if (type === "assignment") {
      if (item.assignStatus && item.assignmentEnabled) return "Assignment already sent";
      return "Send assignment";
    }

    if (type === "tool") {
      if (item.tool_enabled) return "Tool already sent";
      return "Send tool";
    }

    return "";
  };

  const executeToggle = async (apiFunc, sessionId, type, item) => {
    const key = `${type}-${sessionId}`;
    setToggleLoading((prev) => ({ ...prev, [key]: true }));

    try {
      let payload = {
        science_of_self_session_id: sessionId,
      };

      if (type === "Support Document") {
        payload.supported_doc_enabled = true;
      } else if (type === "Tool") {
        payload.tool_enabled = true;
        payload.tool_id = item?.tool_id;
        payload.is_locked = false;
      } else if (type === "Assignment") {
        payload.assignment_enabled = true;
      }

      const resultAction = await dispatch(apiFunc(payload));

      if (apiFunc.fulfilled.match(resultAction)) {
        SweetAlertService.showSuccess({
          title: "Success!",
          message: resultAction.payload?.message || `${type} sent successfully.`,
        });
        onRefresh && onRefresh();
      } else {
        const error = resultAction.payload || resultAction.error;
        SweetAlertService.showError({
          title: "Error!",
          message: error?.message || error || `Failed to update ${type.toLowerCase()}`,
        });
      }
    } catch (err) {
      SweetAlertService.showError({
        title: "Error!",
        message: err?.message || "An unexpected error occurred",
      });
    } finally {
      setToggleLoading((prev) => ({ ...prev, [key]: false }));
    }
  };

  const handleAssignStatus = async (item, status) => {
    const sessionId = item.company_session_id || item.id;
    if (!sessionId) {
      SweetAlertService.showError({
        title: "Error!",
        message: "Session id not found for status update",
      });
      return;
    }
    setStatusLoading((prev) => ({ ...prev, [sessionId]: true }));
    try {
      const payload = {
        science_of_self_id: Number(scienceId),
        science_of_self_session_id: sessionId,
        assign_status: status,
        ...(status === true && { mark_completed: status }),
      };
      const resultAction = await dispatch(enableDisableScienceOfSelfSession(payload));
      if (enableDisableScienceOfSelfSession.fulfilled.match(resultAction)) {
        onRefresh && onRefresh();
        const statusMessage =
          status === true
            ? "Session completed successfully."
            : "Session cancelled successfully.";
        SweetAlertService.showSuccess({
          title: "Success!",
          message: statusMessage,
        });
      } else {
        const err = resultAction.payload || resultAction.error;
        SweetAlertService.showError({
          title: "Error!",
          message: err?.message || err || "Failed to update session status",
        });
      }
    } catch (err) {
      SweetAlertService.showError({
        title: "Error!",
        message: err?.message || "Failed to update session status",
      });
    } finally {
      setStatusLoading((prev) => ({ ...prev, [sessionId]: false }));
    }
  };
  const onToolToggle = (checked, item) => {
    if (!checked && item.tool_enabled) {
      SweetAlertService.showWarning({
        title: "Action Not Allowed",
        message: "Tool access cannot be disabled once enabled.",
      });
      return;
    }

    openConfirmationModal(
      "Send Tool?",
      "Are you sure you want to send the tool for this session?",
      () => executeToggle(enableDisableTool, item.id, "Tool", item)
    );
  };

  const onResourceToggle = (checked, item) => {
    if (!checked && item.supported_doc_enabled) {
      SweetAlertService.showWarning({
        title: "Action Not Allowed",
        message: "Support document access cannot be disabled once enabled.",
      });
      return;
    }

    openConfirmationModal(
      "Send Supported Documents?",
      "Are you sure you want to send the supported documents for this session?",
      () =>
        executeToggle(
          enableDisableSupportDocument,
          item.id,
          "Support Document",
          item
        )
    );
  };

  const headerClass =
    "text-start px-4 py-3 font-lato font-medium text-sm leading-[1.5] text-[#475467] whitespace-nowrap";
  const cellClass =
    "text-start px-4 py-3 font-lato font-medium text-sm leading-[1.5] text-[#1D2939] whitespace-nowrap";

  return (
    <>
      <Tooltip
        id="session-tooltip"
        place="top"
        className="!bg-gray-900 !text-white !text-xs !rounded-lg !px-3 !py-2 !z-50 !max-w-[250px]"
      />

      <div className="border rounded-lg border-gray-200 overflow-x-auto bg-white">
        <Table>
          <THead>
            <Tr className="bg-gray-50 border-b border-gray-200">
              <Th className={headerClass}>S No.</Th>
              <Th className={headerClass}>Session Name</Th>
              <Th className={headerClass}>Tool Name</Th>
              <Th className={headerClass}>Date</Th>
              <Th className={headerClass}>Status</Th>
              <Th className={headerClass}>Tool</Th>
              <Th className={headerClass}>Supported Documents</Th>
              <Th className={headerClass}>Assignment</Th>
              <Th className="text-center px-4 py-3 font-lato font-medium text-sm leading-[1.5] text-[#475467] whitespace-nowrap">
                Status
              </Th>
              <Th className="text-center px-4 py-3 font-lato font-medium text-sm leading-[1.5] text-[#475467] whitespace-nowrap">
                Action
              </Th>
            </Tr>
          </THead>

          <TBody>
            {loading ? (
              <Tr>
                <Td colSpan={10} className="py-10 text-center">
                  <ThreeDotBouncingLoader />
                </Td>
              </Tr>
            ) : sampleData.length > 0 ? (
              sampleData.map((item, index) => {
                // Map API keys to consistent keys
                console.log("Mapping item:", item);
                const toolEnabled = item.tool_enabled ?? item.raw?.tool_enabled ?? false;
                const supportedDocEnabled = item.supported_doc_enabled ?? item.raw?.supported_doc_enabled ?? false;
                const assignmentEnabled = item.assignment_enabled ?? item.raw?.assignment_enabled ?? false;
                const assignStatus = item.assignStatus ?? item.assign_status ?? false;
                console.log("assignmentEnabled", assignmentEnabled, assignStatus)
                const status = item.status?.toLowerCase();
                const areActionsDisabled = status === "completed" || status === "cancelled";
                const statusKey = item.company_session_id || item.id;

                const isDocsDisabled = !!supportedDocEnabled || areActionsDisabled;
                const isToolDisabled = !!toolEnabled || areActionsDisabled;

                // Consistent tooltip logic, now takes item as parameter
                const getToggleTooltip = (type, item) => {
                  if (!item) return "";
                  const status = item.status?.toLowerCase();
                  if (status === "cancelled") return "Session is cancelled, actions are disabled";
                  if (status === "completed") return "Session is completed, actions are disabled";
                  if (type === "docs") {
                    if (supportedDocEnabled) return "Supported document already sent";
                    return "Send the supported document";
                  }
                  if (type === "assignment") {
                    if (assignStatus && assignmentEnabled) return "Assignment already sent";
                    return "Send assignment";
                  }
                  if (type === "tool") {
                    if (toolEnabled) return "Tool already sent";
                    return "Send tool";
                  }
                  return "";
                };

                return (
                  <Tr
                    key={item.id}
                    className="border-b hover:bg-gray-50 transition-colors"
                  >
                    <Td className={cellClass}>
                      {String(
                        (currentPage - 1) * pageLimit + (index + 1)
                      ).padStart(2, "0")}
                    </Td>

                    <Td className={cellClass}>{item.sessionName || ""}</Td>

                    <Td className={cellClass}>{formatToolName(item.tool)}</Td>

                    <Td className={cellClass}>
                      {item.dateTime || item.date || ""}
                    </Td>

                    <Td className={cellClass}>{getStatusBadge(item.status)}</Td>

                    {/* Tool */}
                    <Td className={cellClass}>
                      <div className="flex items-center gap-2">
                        {toggleLoading[`Tool-${item.id}`] ? (
                          <div className="w-10 h-5 flex items-center justify-center">
                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-[#FF8E1C]"></div>
                          </div>
                        ) : (
                          <div className="relative group inline-block">
                            <div className={isToolDisabled ? "pointer-events-none" : ""}>
                              <Switcher
                                onChange={(checked) => onToolToggle(checked, item)}
                                checked={!!toolEnabled}
                                disabled={isToolDisabled}
                              />
                            </div>

                            {/* Tooltip */}
                            <div className="absolute left-1/2 -translate-x-1/2 -top-10 opacity-0 group-hover:opacity-100 transition pointer-events-none z-10">
                              <div className="bg-white text-black text-sm px-3 py-2 rounded shadow-[0px_8px_16px_-2px_rgba(27,33,44,0.12)] whitespace-nowrap">
                                {getToggleTooltip("tool", item)}
                              </div>
                              <div className="w-2 h-2 bg-white rotate-45 absolute left-1/2 -translate-x-1/2 top-full -mt-1"></div>
                            </div>
                          </div>
                        )}
                      </div>
                    </Td>

                    {/* Supported Documents */}
                    <Td className={cellClass}>
                      <div className="flex items-center gap-2">
                        {toggleLoading[`Support Document-${item.id}`] ? (
                          <div className="w-10 h-5 flex items-center justify-center">
                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-[#FF8E1C]"></div>
                          </div>
                        ) : (
                          <div className="relative group inline-block">
                            <div className={isDocsDisabled ? "pointer-events-none" : ""}>
                              <Switcher
                                onChange={(checked) => onResourceToggle(checked, item)}
                                checked={!!supportedDocEnabled}
                                disabled={isDocsDisabled}
                              />
                            </div>

                            {/* Tooltip */}
                            <div className="absolute left-1/2 -translate-x-1/2 -top-10 opacity-0 group-hover:opacity-100 transition pointer-events-none z-10">
                              <div className="bg-white text-black text-sm px-3 py-2 rounded shadow-[0px_8px_16px_-2px_rgba(27,33,44,0.12)] whitespace-nowrap">
                                {getToggleTooltip("docs", item)}
                              </div>
                              <div className="w-2 h-2 bg-white rotate-45 absolute left-1/2 -translate-x-1/2 top-full -mt-1"></div>
                            </div>
                          </div>
                        )}
                      </div>
                    </Td>

                    {/* Assignment */}
                    <Td className={cellClass}>
                      {((assignmentEnabled == true) && (assignStatus == true)) ? (
                        <div className="relative group inline-block">
                          <span className="text-[#1D2939] text-sm font-medium">
                            {truncateText(item.assignment, 18)}
                          </span>

                          {/* Tooltip (only when needed) */}
                          {item.assignment?.length > 18 && (
                            <div className="absolute left-1/2 -translate-x-1/2 -top-10 opacity-0 group-hover:opacity-100 transition pointer-events-none z-10">
                              <div className="bg-white text-black text-sm px-3 py-2 rounded shadow-[0px_8px_16px_-2px_rgba(27,33,44,0.12)] whitespace-nowrap">
                                {item.assignment}
                              </div>
                              <div className="w-2 h-2 bg-white rotate-45 absolute left-1/2 -translate-x-1/2 top-full -mt-1"></div>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="relative group inline-block">
                          <div className={areActionsDisabled ? "pointer-events-none" : ""}>
                            <button
                              onClick={() => {
                                if (!areActionsDisabled) {
                                  openConfirmationModal(
                                    "Send Assignment?",
                                    "Are you sure you want to send the assignment for this session?",
                                    () =>
                                      executeToggle(
                                        enableDisableAssignment,
                                        item.id,
                                        "Assignment",
                                        item
                                      )
                                  );
                                }
                              }}
                              className={`px-3 py-1 rounded text-xs flex items-center justify-center min-w-[50px] text-white ${areActionsDisabled
                                ? "bg-gray-400 cursor-not-allowed"
                                : "bg-[#FF8E1C] hover:bg-[#E67D0F]"
                                }`}
                              disabled={
                                toggleLoading[`Assignment-${item.id}`] || areActionsDisabled
                              }
                            >
                              {toggleLoading[`Assignment-${item.id}`] ? (
                                <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
                              ) : (
                                "Send"
                              )}
                            </button>
                          </div>

                          {/* Tooltip */}
                          <div className="absolute left-1/2 -translate-x-1/2 -top-10 opacity-0 group-hover:opacity-100 transition pointer-events-none z-10">
                            <div className="bg-white text-black text-sm px-3 py-2 rounded shadow-[0px_8px_16px_-2px_rgba(27,33,44,0.12)] whitespace-nowrap">
                              {getToggleTooltip("assignment", item)}
                            </div>
                            <div className="w-2 h-2 bg-white rotate-45 absolute left-1/2 -translate-x-1/2 top-full -mt-1"></div>
                          </div>
                        </div>
                      )}
                    </Td>

                    {/* Status Icons */}
                    <Td className="px-4 py-3 font-lato font-medium text-sm leading-[1.5] text-[#1D2939] whitespace-nowrap">
                      <div className="flex gap-2 justify-center items-center">
                        {statusLoading[statusKey] ? (
                          <div className="w-10 h-5 flex items-center justify-center">
                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-[#FF8E1C]"></div>
                          </div>
                        ) : item.status?.toLowerCase() === "cancelled" ? (
                          <button
                            disabled
                            className="text-red-600 opacity-50 cursor-not-allowed"
                            aria-label="Session cancelled"
                            data-tooltip-id="session-tooltip"
                            data-tooltip-content="Cancelled"
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 21 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13.6844 10L19.8296 3.88889C20.7235 3 20.7235 1.66667 19.8296 0.777778C19.4944 0.333333 18.9358 0 18.3771 0C17.8184 0 17.2598 0.222222 16.8129 0.666667L10.5559 6.88889L4.41061 0.777778C3.51676 -0.111111 2.06425 -0.111111 1.28212 0.777778C0.835195 1.11111 0.5 1.66667 0.5 2.33333C0.5 3 0.723464 3.44444 1.17039 3.88889L7.31564 10L1.17039 16.1111C0.835195 16.5556 0.5 17.1111 0.5 17.7778C0.5 18.3333 0.723464 18.8889 1.17039 19.3333C1.61732 19.7778 2.17598 20 2.73464 20C3.2933 20 3.85196 19.7778 4.29888 19.3333L10.4441 13.2222L16.5894 19.3333C17.4832 20.2222 18.9358 20.2222 19.7179 19.3333C20.6117 18.4444 20.6117 17 19.7179 16.2222L13.6844 10Z"
                                fill="#B42318"
                              />
                            </svg>
                          </button>
                        ) : item.status?.toLowerCase() === "completed" ? (
                          // <button
                          //   disabled
                          //   className="text-green-600 opacity-50 cursor-not-allowed"
                          //   aria-label="Session completed"
                          //   data-tooltip-id="session-tooltip"
                          //   data-tooltip-content="Completed"
                          // >
                          //   <svg
                          //     width="18"
                          //     height="18"
                          //     viewBox="0 0 25 20"
                          //     fill="none"
                          //     xmlns="http://www.w3.org/2000/svg"
                          //   >
                          //     <path
                          //       d="M2.5 10.7297L8.68692 17L22.5 3"
                          //       stroke="#027A48"
                          //       strokeWidth="4.5"
                          //       strokeLinecap="round"
                          //       strokeLinejoin="round"
                          //     />
                          //   </svg>
                          // </button>
                          <div className="relative group inline-block">
                            <button
                              disabled
                              className="text-green-600 opacity-50 cursor-not-allowed"
                              aria-label="Session completed"
                            >
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 25 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M2.5 10.7297L8.68692 17L22.5 3"
                                  stroke="#027A48"
                                  strokeWidth="4.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>

                            {/* Tooltip */}
                            <div className="absolute left-1/2 -translate-x-1/2 -top-10 opacity-0 group-hover:opacity-100 transition pointer-events-none z-10">
                              <div className="bg-white text-black text-sm px-3 py-2 rounded shadow-[0px_8px_16px_-2px_rgba(27,33,44,0.12)] whitespace-nowrap">
                                Completed
                              </div>
                              <div className="w-2 h-2 bg-white rotate-45 absolute left-1/2 -translate-x-1/2 top-full -mt-1"></div>
                            </div>
                          </div>
                        ) : (
                          <>
                            {/* <div
                              data-tooltip-id="session-tooltip"
                              data-tooltip-content="Complete session"
                              className="inline-block"
                            >
                              <button
                                onClick={() =>
                                  openConfirmationModal(
                                    "Complete Session?",
                                    "Are you sure you want to mark this session as completed?",
                                    () => handleAssignStatus(item, true)
                                  )
                                }
                                className="text-green-600 hover:text-green-700"
                                aria-label="Complete session"
                              >
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 25 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M2.5 10.7297L8.68692 17L22.5 3"
                                    stroke="#027A48"
                                    strokeWidth="4.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </button>
                            </div>

                            <div
                              data-tooltip-id="session-tooltip"
                              data-tooltip-content="Cancel session"
                              className="inline-block"
                            >
                              <button
                                onClick={() =>
                                  openConfirmationModal(
                                    "Cancel Session?",
                                    "Are you sure you want to cancel this session?",
                                    () => handleAssignStatus(item, false)
                                  )
                                }
                                className="text-red-600 hover:text-red-700"
                                aria-label="Cancel session"
                              >
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 21 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M13.6844 10L19.8296 3.88889C20.7235 3 20.7235 1.66667 19.8296 0.777778C19.4944 0.333333 18.9358 0 18.3771 0C17.8184 0 17.2598 0.222222 16.8129 0.666667L10.5559 6.88889L4.41061 0.777778C3.51676 -0.111111 2.06425 -0.111111 1.28212 0.777778C0.835195 1.11111 0.5 1.66667 0.5 2.33333C0.5 3 0.723464 3.44444 1.17039 3.88889L7.31564 10L1.17039 16.1111C0.835195 16.5556 0.5 17.1111 0.5 17.7778C0.5 18.3333 0.723464 18.8889 1.17039 19.3333C1.61732 19.7778 2.17598 20 2.73464 20C3.2933 20 3.85196 19.7778 4.29888 19.3333L10.4441 13.2222L16.5894 19.3333C17.4832 20.2222 18.9358 20.2222 19.7179 19.3333C20.6117 18.4444 20.6117 17 19.7179 16.2222L13.6844 10Z"
                                    fill="#B42318"
                                  />
                                </svg>
                              </button>
                            </div> */}

                            {/* Complete Session */}
                            <div className="relative group inline-block">
                              <button
                                onClick={() =>
                                  openConfirmationModal(
                                    "Complete Session?",
                                    "Are you sure you want to mark this session as completed?",
                                    () => handleAssignStatus(item, true)
                                  )
                                }
                                className="text-green-600 hover:text-green-700"
                                aria-label="Complete session"
                              >
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 25 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M2.5 10.7297L8.68692 17L22.5 3"
                                    stroke="#027A48"
                                    strokeWidth="4.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </button>

                              {/* Tooltip */}
                              <div className="absolute left-1/2 -translate-x-1/2 -top-10 opacity-0 group-hover:opacity-100 transition pointer-events-none z-10">
                                <div className="bg-white text-black text-sm px-3 py-2 rounded shadow-[0px_8px_16px_-2px_rgba(27,33,44,0.12)] whitespace-nowrap">
                                  Complete session
                                </div>
                                <div className="w-2 h-2 bg-white rotate-45 absolute left-1/2 -translate-x-1/2 top-full -mt-1"></div>
                              </div>
                            </div>

                            {/* Cancel Session */}
                            <div className="relative group inline-block">
                              <button
                                onClick={() =>
                                  openConfirmationModal(
                                    "Cancel Session?",
                                    "Are you sure you want to cancel this session?",
                                    () => handleAssignStatus(item, false)
                                  )
                                }
                                className="text-red-600 hover:text-red-700"
                                aria-label="Cancel session"
                              >
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 21 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M13.6844 10L19.8296 3.88889C20.7235 3 20.7235 1.66667 19.8296 0.777778C19.4944 0.333333 18.9358 0 18.3771 0C17.8184 0 17.2598 0.222222 16.8129 0.666667L10.5559 6.88889L4.41061 0.777778C3.51676 -0.111111 2.06425 -0.111111 1.28212 0.777778C0.835195 1.11111 0.5 1.66667 0.5 2.33333C0.5 3 0.723464 3.44444 1.17039 3.88889L7.31564 10L1.17039 16.1111C0.835195 16.5556 0.5 17.1111 0.5 17.7778C0.5 18.3333 0.723464 18.8889 1.17039 19.3333C1.61732 19.7778 2.17598 20 2.73464 20C3.2933 20 3.85196 19.7778 4.29888 19.3333L10.4441 13.2222L16.5894 19.3333C17.4832 20.2222 18.9358 20.2222 19.7179 19.3333C20.6117 18.4444 20.6117 17 19.7179 16.2222L13.6844 10Z"
                                    fill="#B42318"
                                  />
                                </svg>
                              </button>

                              {/* Tooltip */}
                              <div className="absolute left-1/2 -translate-x-1/2 -top-10 opacity-0 group-hover:opacity-100 transition pointer-events-none z-10">
                                <div className="bg-white text-black text-sm px-3 py-2 rounded shadow-[0px_8px_16px_-2px_rgba(27,33,44,0.12)] whitespace-nowrap">
                                  Cancel session
                                </div>
                                <div className="w-2 h-2 bg-white rotate-45 absolute left-1/2 -translate-x-1/2 top-full -mt-1"></div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </Td>

                    {/* View */}
                    <Td className="whitespace-nowrap">
                      <CommonIconButton
                      type="view" onClick={() => handleView(item)}/>
                      
                 
                    </Td>
                  </Tr>
                );
              })
            ) : (
              <Tr>
                <Td
                  colSpan={9}
                  className="text-center font-lato font-medium text-sm leading-[1.5] text-[#1D2939] py-6"
                >
                  No matching records found
                </Td>
              </Tr>
            )}
          </TBody>
        </Table>
      </div>

      <AddEditSession
        dialogOpen={dialogOpen}
        onDialogClose={() => {
          setDialogOpen(false);
          setSelectedSession(null);
        }}
        sessionData={selectedSession}
        mode={mode}
      />

      <ArchiveModal
        dialogOpen={isOpen}
        onDialogClose={() => setIsOpen(false)}
      />

      <ConfirmationModal
        dialogOpen={confirmationModal.isOpen}
        onDialogClose={handleConfirmationNo}
        title={confirmationModal.title}
        message={confirmationModal.message}
        onConfirm={handleConfirmationYes}
        showYesNo={true}
      />
    </>
  );
};

export default SessionList;